<lib-button-loading
  *ngIf="files.length > 0"
  color="primary"
  [loading]="saving"
  (clickEvent)="uploadAll()"
  [invalid]="disabled"
  >{{ uploadAllLabel }}
</lib-button-loading>
<ng-content></ng-content>
